var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { mapState } from 'vuex';
import { toYuan, toFen } from '../../utils/unit-conversion';
import eventBus from '../../utils/fresh-table';
import table from '../../components/console-common/table.vue';
import selectCustom from '../../components/console-common/select-custom.vue';
import contractBoard from '../../components/console-common/contract-board.vue';
import commonVideo from '../../components/console-common/common-video.vue';
import contractView from '../../components/contract/contract-view.vue';
export default Vue.extend({
    name: 'login',
    components: {
        'el-result-list': table,
        'el-contract-board': contractBoard,
        'el-select-custom': selectCustom,
        'el-common-video': commonVideo,
        'el-contract-view': contractView,
    },
    computed: __assign({}, mapState('info', {
        cityList: 'cityList',
        signCompanyList: 'signCompanyList',
        settleCompanyList: 'settleCompanyList',
    }), { isHasContractMsg: function () {
            // const list = this.dialogConfig.detail.list
            var list = this.contractData;
            return list && list.length > 0;
        },
        stepStatus: function () {
            var status = this.dialogConfig.currentBtn.status;
            return status === 0 || status === 1;
        } }),
    watch: {
        cityList: function (val) {
            this.searchConfig[5].option = val;
        },
        signCompanyList: function (val) {
            val[0] && val[0].clearSelf === '_NODATA_SIGN' ? val.splice(0, 1) : '';
            this.searchConfig[6].option = val;
        },
        settleCompanyList: function (val) {
            val[0] && val[0].clearSelf === '_NODATA_SETTLEMENT'
                ? val.splice(0, 1)
                : '';
            this.searchConfig[7].option = val;
        },
        contractData: function (val) {
            if (val.length === 1) {
                return this.getCurrentContract(0);
            }
        },
    },
    data: function () {
        var info = this.$store.state.info;
        return {
            contractData: [],
            isCheckContractBoard: false,
            dialogConfig: {
                detail: {
                    newPlanAmount: 0,
                    orderNo: '',
                    status: '',
                    list: [],
                },
                currentKeys: {
                    type: 'amountType',
                    typeText: 'amountTypeText',
                    val: 'OTHER',
                },
                addDetailFlag: false,
                btns: [
                    {
                        lBtn: '取 消',
                        rBtn: '下一步',
                        status: 0,
                        callback: function (fun) {
                            fun(this.status + 1);
                        },
                    },
                    {
                        lBtn: '取 消',
                        rBtn: '确认并继续',
                        status: 1,
                        callback: function (fun) {
                            fun(this.status + 1);
                        },
                    },
                    {
                        lBtn: '上一步',
                        rBtn: '确定添加',
                        status: 2,
                        callback: function (fun) {
                            var this_ = fun(this.status + 1);
                            this_.submitDetail();
                        },
                        lBtnCallback: function (fun) {
                            fun(this.status - 1);
                        },
                    },
                ],
                currentBtn: {
                    lBtn: '',
                    rBtn: '',
                    status: 0,
                },
            },
            detailForm: {
                contractCode: '',
                amountType: '',
                amountTypeText: '',
                amount: '',
                repayTime: '',
                repayRange: [],
            },
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: '',
            },
            rules: {
                amountType: [
                    { required: true, message: '请选择费用类型', trigger: 'change' },
                ],
                amount: [
                    { required: true, message: '请输入还款金额', trigger: 'blur' },
                    { required: true, validator: this.validatorNum, trigger: 'blur' },
                ],
                repayTime: [
                    { required: true, message: '请选择还款日期', trigger: 'change' },
                ],
            },
            options: [
                {
                    val: 'MONTHLY_RENT',
                    label: '租金/月供',
                },
                {
                    val: 'PUNISHMENT',
                    label: '违章罚款',
                },
                {
                    val: 'DEPOSIT',
                    label: '押金',
                },
                {
                    val: 'MANAGEMENT',
                    label: '管理费',
                },
                {
                    val: 'INSURANCE',
                    label: '保险',
                },
            ],
            isAddCostType: true,
            otherType: '',
            content: {
                txt: '这里可以补录线下还款明细哦！',
                left: '-32px',
            },
            exportConfig: {
                fileName: '还款明细',
                keyUrl: '/proxy/api/record/export',
                statusUrl: '/proxy/api/getFileUrl',
                statusKeys: 'fileGiftKey',
            },
            requestConfig: {
                url: '/proxy/api/record/page',
                method: 'post',
            },
            defaultSearch: {
                inputSearch: 'driverName',
            },
            searchConfig: [
                {
                    type: 'inputSearch',
                    key: 'inputSearch',
                    placeholder: '请输入内容',
                    option: [
                        {
                            label: '司机姓名',
                            val: 'driverName',
                        },
                        {
                            label: '合同号',
                            val: 'contractCode',
                        },
                        {
                            label: '手机号',
                            val: 'driverMobile',
                        },
                    ],
                },
                {
                    label: '扣款时间',
                    type: 'dateRange',
                    startTimeKey: 'repayTimeStart',
                    endTimeKey: 'repayTimeEnd',
                },
                {
                    label: '扣款状态',
                    key: 'status',
                    type: 'select',
                    placeholder: '请选择扣款状态',
                    option: [
                        {
                            label: '不限',
                            val: '',
                        },
                        {
                            label: '成功',
                            val: 'SUCCESS',
                        },
                        {
                            label: '失败',
                            val: 'FAILED',
                        },
                    ],
                },
                {
                    label: '计划扣款模式',
                    key: 'deductMode',
                    type: 'select',
                    placeholder: '请选择扣款模式',
                    option: [
                        {
                            label: '不限',
                            val: '',
                        },
                        {
                            label: '日扣平均',
                            val: 'DAY_AVERAGE',
                        },
                        {
                            label: '日扣优先',
                            val: 'DAY_GREED',
                        },
                        {
                            label: '主动还款',
                            val: 'ACTIVE',
                        },
                    ],
                },
                {
                    label: '实际还款方式',
                    key: 'repayMethod',
                    type: 'select',
                    placeholder: '请选择实际还款方式',
                    option: [
                        {
                            label: '不限',
                            val: '',
                        },
                        {
                            label: '余额代扣',
                            val: 'BALANCE',
                        },
                        {
                            label: '主动还款',
                            val: 'ACTIVE',
                        },
                        {
                            label: '线下还款',
                            val: 'OFFLINE',
                        },
                    ],
                },
                {
                    label: '城市',
                    key: 'cityCode',
                    type: 'select',
                    placeholder: '',
                    option: info.cityList,
                },
                {
                    label: '所属公司',
                    key: 'signCompanyName',
                    type: 'select',
                    clearable: true,
                    placeholder: '',
                    option: info.signCompanyList,
                },
                {
                    label: '结算公司',
                    key: 'settlementCompanyName',
                    type: 'select',
                    clearable: true,
                    placeholder: '',
                    option: info.settleCompanyList,
                },
            ],
            tableConfig: [
                {
                    label: '合同号',
                    prop: 'contractCode',
                    tooltip: true,
                    width: '150px',
                    fixed: 'left',
                },
                {
                    label: '司机姓名',
                    tooltip: true,
                    prop: 'driverName',
                    width: '150px',
                },
                {
                    label: '手机号',
                    prop: 'driverMobile',
                    width: '130px',
                    tooltip: true,
                },
                {
                    label: '扣款周期',
                    prop: 'planStartTime',
                    sortable: 'custom',
                    sortableUp: 'START_TIME_ASC',
                    sortableDown: 'START_TIME_DESC',
                    width: '225px',
                    tooltip: true,
                    formatter: function (val, row) {
                        var planStartTime = row.planStartTime, planEndTime = row.planEndTime;
                        if (planStartTime === null && planEndTime === null) {
                            return '--';
                        }
                        return (moment(row.planStartTime).format('YYYY-MM-DD') +
                            ' 至 ' +
                            moment(row.planEndTime).format('YYYY-MM-DD'));
                    },
                },
                {
                    label: '扣款时间',
                    prop: 'payTime',
                    sortable: 'custom',
                    sortableUp: 'PAY_TIME_ASC',
                    sortableDown: 'PAY_TIME_DESC',
                    width: '140px',
                    tooltip: true,
                    formatter: function (val) {
                        return moment(val).format('YYYY-MM-DD');
                    },
                },
                {
                    label: '扣款金额(元)',
                    prop: 'amount',
                    width: '130px',
                    tooltip: true,
                    formatter: function (val) {
                        return toYuan(val).toFixed(2);
                    },
                },
                {
                    label: '本期待还金额(元)',
                    prop: 'remains',
                    width: '170px',
                    tooltip: true,
                    formatter: function (val) {
                        return toYuan(val).toFixed(2);
                    },
                },
                {
                    label: '扣款状态',
                    prop: 'status',
                    width: '130px',
                    tooltip: true,
                    formatter: function (val) {
                        var change = {
                            SUCCESS: '成功',
                            FAILED: '失败',
                        };
                        return change[val];
                    },
                },
                {
                    label: '费用类型',
                    prop: 'amountType',
                    width: '110px',
                    tooltip: true,
                    formatter: function (val, row) {
                        var amountTypeText = row.amountTypeText;
                        var text = '';
                        switch (val) {
                            case 'MONTHLY_RENT':
                                text = '租金/月供';
                                break;
                            case 'PUNISHMENT':
                                text = '违章罚款';
                                break;
                            case 'DEPOSIT':
                                text = '押金';
                                break;
                            case 'MANAGEMENT':
                                text = '管理费';
                                break;
                            case 'INSURANCE':
                                text = '保险费';
                                break;
                            default:
                                text = amountTypeText || '--';
                        }
                        return text || '--';
                    },
                },
                {
                    label: '计划扣款模式',
                    prop: 'deductMode',
                    width: '140px',
                    tooltip: true,
                    formatter: function (val) {
                        var change = {
                            DAY_AVERAGE: '日扣平均',
                            DAY_GREED: '日扣优先',
                            ACTIVE: '主动还款',
                        };
                        return change[val] ? change[val] : '--';
                    },
                },
                {
                    label: '实际还款方式',
                    prop: 'repayMethod',
                    width: '200px',
                    tooltip: true,
                    formatter: function (val, row) {
                        var payMethod = row.payMethod;
                        var change = {
                            BALANCE: '余额代扣',
                            ACTIVE: '主动还款',
                            OFFLINE: '线下还款',
                        };
                        var payMethodObj = {
                            OTHER: '微信/支付宝',
                            BALANCE: '余额支付',
                        };
                        var currentRepayMethod = val ? change[val] : '--';
                        var currentPayMethod = val === 'ACTIVE'
                            ? payMethod
                                ? "-" + payMethodObj[payMethod]
                                : '未知'
                            : '';
                        return val
                            ? "" + currentRepayMethod + currentPayMethod
                            : currentRepayMethod;
                    },
                },
                {
                    label: '车牌号',
                    prop: 'plateNumber',
                    width: '130px',
                    tooltip: true,
                },
                {
                    label: '城市',
                    prop: 'cityName',
                    width: '110px',
                    tooltip: true,
                },
                {
                    label: '所属公司',
                    prop: 'signCompanyName',
                    tooltip: true,
                    width: '208px',
                },
                {
                    label: '结算公司',
                    prop: 'settlementCompanyName',
                    tooltip: true,
                    width: '208px',
                },
                {
                    label: '经办人',
                    prop: 'transactorContract',
                    tooltip: true,
                    width: '100px',
                },
                {
                    label: '司管',
                    prop: 'transactorManager',
                    tooltip: true,
                    width: '100px',
                },
            ],
        };
    },
    created: function () {
        this.$store.dispatch('info/GET_COMPANY_ALL', { type: 'SIGN' });
        this.$store.dispatch('info/GET_COMPANY_ALL', { type: 'SETTLEMENT' });
    },
    methods: {
        validatorNum: function (rule, value, callback) {
            var reg = /^[0-9]{1,6}(\.[0-9]{1,2})?$/;
            if (value <= 0) {
                return callback(new Error('数字必须大于0'));
            }
            if (!reg.test(value)) {
                return callback(new Error('最多6位整数，2位小数'));
            }
            else {
                callback();
            }
        },
        openAddDetail: function () {
            this.detailForm = {};
            this.dialogConfig = Object.assign(this.dialogConfig, {
                detail: {
                    newPlanAmount: 0,
                    orderNo: '',
                    status: '',
                    list: [],
                },
                addDetailFlag: false,
                currentBtn: {
                    lBtn: '',
                    rBtn: '',
                    status: 0,
                },
                contractCode: '',
            });
            var dialogConfig = this.dialogConfig;
            dialogConfig.addDetailFlag = true;
            dialogConfig.currentBtn = dialogConfig.btns[0];
        },
        addDetailNext: function (index) {
            var dialogConfig = this.dialogConfig;
            if (index === dialogConfig.btns.length) {
                return this;
            }
            dialogConfig.currentBtn = dialogConfig.btns[index];
            return this;
        },
        addOther: function () {
            this.isAddCostType = false;
        },
        cancleOther: function () {
            this.isAddCostType = true;
        },
        saveOther: function () { },
        getDetail: function () {
            var _this = this;
            this.isCheckContractBoard = false;
            var criteria = this.dialogConfig.criteria;
            this.$request({
                method: 'post',
                url: '/proxy/api/contract/get/fuzzy',
                data: {
                    criteria: criteria,
                },
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode || !res.data || !res.data.length) {
                    _this.contractData = [];
                }
                if (!res.errorCode) {
                    var data = res.data;
                    _this.contractData = [];
                    var leaseFormatter_1 = function (leaseMode) {
                        var txt = {
                            JINGZU: '经租',
                            RONGZU: '融租',
                        };
                        return txt[leaseMode];
                    };
                    data.forEach(function (item) {
                        var obj = {
                            orderNo: '',
                            status: '',
                            active: false,
                            list: [],
                        };
                        obj.orderNo = item.contractCode;
                        obj.status = item.activeState;
                        obj.list = [
                            {
                                key: '司机姓名',
                                val: item.driverName,
                            },
                            {
                                key: '车牌号',
                                val: item.plateNumber,
                                push: 3,
                            },
                            {
                                key: '注册手机号',
                                val: item.driverMobile,
                                span: 24,
                            },
                            {
                                key: '业务模式',
                                val: leaseFormatter_1[item.leaseMode],
                                span: 12,
                            },
                            {
                                key: item.leaseMode === 'JINGZU' ? '总租金' : '总额',
                                val: "\uFFE5" + _this.$utils.toYuan(item.totalAmount),
                                push: 3,
                            },
                            {
                                key: '合同有效期',
                                val: moment(item.startTime).format('YYYY-MM-DD') + " \u81F3 " + moment(item.endTime).format('YYYY-MM-DD'),
                                span: 24,
                            },
                        ];
                        _this.contractData.push(obj);
                    });
                    _this.addDetailNext(1);
                }
            });
        },
        getCurrentContract: function (index) {
            this.contractData.forEach(function (item) {
                item.active = false;
            });
            this.contractData[index]['active'] = true;
            this.dialogConfig.contractCode = this.contractData[index].orderNo;
            this.dialogConfig.detail = this.contractData[index];
            this.isCheckContractBoard = true;
        },
        submitDetail: function () {
            var _this = this;
            var _a = this.detailForm, amountType = _a.amountType, repayTime = _a.repayTime, repayRange = _a.repayRange;
            this.$refs['detailForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                var newPlanAmount = _this.dialogConfig.detail.newPlanAmount;
                var repayPeriodFrom = '';
                var repayPeriodTo = '';
                if (repayRange instanceof Array && repayRange.length > 0) {
                    repayPeriodFrom = moment(repayRange[0]).format('YYYY-MM-DD');
                    repayPeriodTo = moment(repayRange[1]).format('YYYY-MM-DD');
                }
                var params = Object.assign({}, _this.detailForm, {
                    contractCode: _this.dialogConfig.contractCode,
                    repayTime: _this.detailForm.repayTime
                        ? moment(repayTime).format('YYYY-MM-DD HH:mm:ss')
                        : '',
                    repayPeriodFrom: repayPeriodFrom,
                    repayPeriodTo: repayPeriodTo,
                });
                delete params.repayRange;
                params.amount = toFen(params.amount);
                if (amountType === 'MONTHLY_RENT' && newPlanAmount < 0) {
                    return _this.$massage.error('线下还款金额超过了该合同未创建还款计划的金额，请先处理该司机的还款计划');
                }
                _this.$request({
                    url: '/proxy/api/record/offline/add',
                    method: 'post',
                    data: params,
                }).then(function (res) {
                    if (!res || res.errorCode) {
                        return;
                    }
                    eventBus.$emit('freshTable');
                    _this.$message({
                        message: '添加成功！',
                        type: 'success',
                    });
                    _this.dialogConfig.addDetailFlag = false;
                });
            });
        },
        dialogclosed: function () {
            this.$set(this.dialogConfig, 'criteria', '');
            this.contractData = [];
            this.isCheckContractBoard = false;
        },
    },
});
